// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {Modulo} from "services-translation/modules/base/modulo";

import {TraduccionCmpGdprSimpleAawMainMessage, TraduccionCmpGdprSimpleAawMainMessageParams} from "./simple/aaw_main_message";
import {TraduccionCmpGdprSimpleAawOpenConfig} from "./simple/aaw_open_config";

export class TraduccionCmpGdprSimple extends Modulo {
    /* STATIC */
    // public static ID: string = "cmp.gdpr.simple";
    // public static VERSION: Date = new Date("2024-04-19T10:20:36.293Z");
    // public static HASH: string = "5cc0e8892959808c9375055faadedc3b";

    private static CACHE: {[lang: string]: TraduccionCmpGdprSimple} = {};

    public static build(lang: IIdioma): TraduccionCmpGdprSimple {
        return this.CACHE[lang.idioma] ??= new this(lang);
    }

    /* INSTANCE */
    public aaw_open_config: string;

    #aaw_main_message: TraduccionCmpGdprSimpleAawMainMessage;

    private constructor(_lang: IIdioma) {
        super(_lang);

        this.#aaw_main_message = TraduccionCmpGdprSimpleAawMainMessage.build(this._lang);
        this.aaw_open_config = TraduccionCmpGdprSimpleAawOpenConfig.build(this._lang).toString();
    }

    public aaw_main_message(params: Partial<TraduccionCmpGdprSimpleAawMainMessageParams> = {}) {
        return this.#aaw_main_message.render(params);
    }
}

export default (lang: IIdioma)=>TraduccionCmpGdprSimple.build(lang);
